import { APP_CONFIG } from 'mangools-commons/dist/configs/app';
import queryString from 'query-string';
import { parse } from 'sources/parsers/SerpResultDataParser';

import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';
import HumanService from 'mangools-commons/dist/services/HumanService';

// Constants
const ENDPOINT = '/serps-bulk';

/**
 * Data source class handling communication
 * with API for serp result list data.
 */
class SerpBulkResultSource {
    static getData({ accessToken, disableCache, page, params }) {
        let query = null;

        const rawQuery = {
            kw: params.query,
            location_id: params.locationId,
            page,
            seed_location_id: undefined,
        }

        if (params.languageId !== undefined) {
            rawQuery.language_id = params.languageId;
        }

        if (params.seedKw) {
            rawQuery.seedKw = params.seedKw;
            rawQuery.type = 'searchByKw';
        }

        if (params.url) {
            rawQuery.url = params.url;
            rawQuery.seed_location_id = params.seedLocationId;
            rawQuery.type = 'searchByDomain';
        }

        if (disableCache === true) {
            rawQuery.cacheTime = 0;
        }

        query = queryString.stringify(rawQuery)

        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${ENDPOINT}?${query}`;

        return fetch(requestURL, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-Access-Token': accessToken || '',
                'X-Human-Token': HumanService.gen(),
                'X-Mangools-Client': 'app',
            },
        })
            .then(response => {
                if (response.ok) {
                    // No SERP data results
                    if (response.status === 204) {
                        return {
                            error: false,
                            payload: null,
                        };
                    } else {
                        return response
                            .json()
                            .then(data => ({
                                error: false,
                                payload: parse(data),
                            }))
                            .catch(ex => ({
                                error: true,
                                payload: {
                                    requestURL,
                                    status: ErrorCodes.PARSE_ERROR,
                                    text: ex.toString(),
                                },
                            }));
                    }
                } else {
                    return response.json().then(e => ({
                        error: true,
                        payload: {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                            retryAfter: e.error ? e.error.retry_after : null,
                        },
                    }));
                }
            })
            .catch(ex => ({
                error: true,
                payload: {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                },
            }));
    }
}

export default SerpBulkResultSource;
